import type { ToolModule } from '../../core/modules/types'
import { StockView } from './view'

export const stockModule: ToolModule = {
  id: 'stock',
  title: 'Stock Allocation',
  description: 'Allocate shop stock to a sales agent, and accept it from the web (dev/staging).',
  requiresToken: true,
  View: StockView,
}
